export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.7.1',
};
//# sourceMappingURL=buildEnv.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@datadog/browser-rum-core/esm/boot/buildEnv.js
// module id = n8G7
// module chunks = 22 24